import { defineMessages, IntlShape } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";

import selectEntityDialogFactory from "./selectEntityDialogFactory";

const messages = defineMessages({
  deselectAll: {
    id: "selectEntityDialog.teams.deselectAll",
    defaultMessage: "Deselect All",
    description: "Deselect all message for the select teams dialog",
  },
  filterTitle: {
    id: "selectEntityDialog.teams.filterTitle",
    defaultMessage: " Teams",
    description: "Title message for the select teams dialog",
  },
  noEntriesMessage: {
    id: "selectEntityDialog.teams.noEntries",
    defaultMessage: "No Teams Found",
    description: "'No entries' message for the select teams dialog",
  },
  selectAll: {
    id: "selectEntityDialog.teams.selectAll",
    defaultMessage: "Select All",
    description: "Select all message for the select teams dialog",
  },
});

const SelectTeamsDialog = selectEntityDialogFactory<Team>(
  messages.noEntriesMessage,
  (allSelected: boolean, isFiltering: boolean, intl: IntlShape) =>
    (allSelected
      ? intl.formatMessage(messages.deselectAll)
      : intl.formatMessage(messages.selectAll)) +
    (isFiltering ? intl.formatMessage(messages.filterTitle) : "")
);
export default SelectTeamsDialog;
